'use client'

import { useJobStore } from '@stores/job.store'

import type { JobPageItem, TermsConditions } from '@types'

import { useShallow } from 'zustand/react/shallow'

import useServerSideStore from '@hooks/useServerSideStore'

type JobStoreProps = {
  job: JobPageItem
  termsConditions: TermsConditions[]
  postApplyMessage: string | null
}

export default function JobStore({ job, termsConditions, postApplyMessage }: JobStoreProps): null {
  const [initializeStore, clearStore] = useJobStore(useShallow((st) => [st.initializeStore, st.clearStore]))

  useServerSideStore(
    () =>
      initializeStore({
        job,
        tc: termsConditions,
        postApplyMessage,
      }),
    clearStore,
  )
  return null
}
